import * as t from "react";
import { c as e } from "../createReactComponent-58f9bea8.mjs";
import { a as m, r } from "../menu-item-65dd9fa4.mjs";
import { M as E } from "../menu-item-65dd9fa4.mjs";
import "../property-9daa16cd.mjs";
import "../state-7560d4dc.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
import "../class-map-2994e95e.mjs";
import "../slot-controller-fa97ce97.mjs";
import "../icon-c572aa57.mjs";
import "../checkbox-46b40c6a.mjs";
import "../radio-8b0e9514.mjs";
import "../tooltip-cb602d1f.mjs";
const M = e({ tagName: "ex-menu-item", elementClass: m, react: t, events: { onItemSelect: "onItemSelect" }, displayName: "ExMenuItem", registerWebComponent: r });
export {
  M as ExMenuItem,
  E as MenuItemVariant,
  r as register
};
